// utils/unpublishTemplate.js
//
// Removes a form **from the template gallery** but keeps the form itself
// published/usable.  We only flip the template flags – we do NOT change `status`.
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Un‑publishes a template (global or organization scope) without deleting
 * or de‑publishing the original form.
 *
 * @param {Object} params
 * @param {string}  params.formId       Firestore document ID of the form
 * @param {Object?} params.currentUser  Auth user (optional – for audit trail)
 *
 * @returns {Promise<{status:'success'|'error', message:string}>}
 */
export async function unpublishTemplate({ formId, currentUser = null }) {
//  console.log('[unpublishTemplate] Starting with:', { formId });

  if (!formId) {
    console.warn('[unpublishTemplate] Missing formId');
    return { status: 'error', message: 'Missing formId.' };
  }

  try {
    /* we ONLY clear the template flags */
    const updateData = {
      isTemplate       : false,
      templateScope    : null,
      templateCategory : null,
      unpublishedAt    : serverTimestamp(),
      lastModified     : serverTimestamp(),
    };

    if (currentUser?.uid) {
      updateData.unpublishedBy = currentUser.uid;
    }

    const ref = doc(db, 'forms', formId);
//    console.log('[unpublishTemplate] Updating Firestore doc with:', updateData);
    await updateDoc(ref, updateData);

//    console.log('[unpublishTemplate] Success – gallery flags removed');
    return { status: 'success', message: 'Template removed from gallery.' };
  } catch (err) {
    console.error('[unpublishTemplate] ❌ Error:', err);
    return { status: 'error', message: err.message };
  }
}
